export default {
  title: 'Indicadores de función',
  subtitle: 'Activa o desactiva funciones de la plataforma para {{company}}.',
  no_company: 'Selecciona un restaurante para gestionar sus indicadores de función.',
  columns: {
    feature: 'Función',
    status: 'Estado',
  },
  flags: {
    paypal_standalone: {
      name: 'PayPal (directo)',
      description:
        'Permite que este restaurante acepte pagos de PayPal directamente en su propia cuenta de PayPal. Activado por defecto para restaurantes de socios facturados por Foodamigos, donde la comisión de servicio al cliente también se cobra en estos pagos y la parte de la plataforma se factura al socio.',
    },
    vip_free_flyers: {
      name: 'Volantes gratuitos mensuales',
      description:
        'Envía automáticamente 500 volantes promocionales al mes a este restaurante (por defecto: activado para nivel VIP y Star).',
    },
    custom_store_seo: {
      name: 'SEO personalizado de la tienda',
      description: 'Permite que este restaurante gestione la configuración SEO personalizada de su tienda online.',
    },
    external_printer: {
      name: 'Impresora de tickets externa',
      description:
        'Permite que este restaurante conecte una impresora de tickets en red a la app del terminal, en lugar de la impresora integrada.',
    },
    stripe_payment_element: {
      name: 'Checkout con Stripe Payment Element',
      description:
        'Permite que la propia cuenta de Stripe del restaurante decida qué métodos de pago ofrece el checkout. Actívalo solo cuando su plataforma de Stripe tenga configurados los métodos de pago para cuentas conectadas.',
    },
  },
  toasts: {
    enabled: 'Función activada.',
    disabled: 'Función desactivada.',
    error: 'No se pudo actualizar la función. Inténtalo de nuevo.',
    load_error: 'No se pudieron cargar los indicadores de función.',
  },
};
